import { ServiceResult } from "../data.types";
import axios from "axios";

interface Message {
  channel: string;
  payload: ServiceResult;
}

export class StaticDataService {
  basePath = new URL("https://data.mahetec.info/nodered/nasa/");

  getLiveEventsSchedule() {
    return new Promise<ServiceResult>(async (resolve, _reject) => {
      const res = await axios.get(
        new URL("nasatv-schedule", this.basePath).toString(),
      );

      if (res.status === 200) {
        resolve({
          data: {
            ...res.data,
            data: {
              schedule: res.data.data.schedule.map((entry: any) => ({
                ...entry,
                time: new Date(entry.time),
              })),
            },
            effective: new Date(res.data.effective),
            timestamp: new Date(res.data.timestamp),
          },
        });
      } else {
        resolve({
          error: new Error(
            `Request failed with error: ${res.status} ${res.statusText}`,
          ),
        });
      }
    });
  }

  getArtemisBlog() {
    return new Promise<ServiceResult>(async (resolve, _reject) => {
      const res = await axios.get(
        new URL("blogs?name=artemis", this.basePath).toString(),
      );

      if (res.status === 200) {
        resolve({
          data: {
            ...res.data,
            timestamp: new Date(res.data.timestamp),
            data: {
              metadata: {
                ...res.data.data.metadata,
                lastBuildDate: new Date(res.data.data.metadata.lastBuildDate),
              },
              entries: res.data.data.entries.map((entry: any) => ({
                ...entry,
                published: new Date(entry.published),
              })),
            },
          },
        });
      } else {
        resolve({
          error: new Error(
            `Request failed with error: ${res.status} ${res.statusText}`,
          ),
        });
      }
    });
  }

  getLiveEvents() {
    return new Promise<ServiceResult>(async (resolve, _reject) => {
      const res = await axios.get(
        new URL("liveevents", this.basePath).toString(),
      );

      if (res.status === 200) {
        resolve({
          data: {
            ...res.data,
            timestamp: new Date(res.data.timestamp),
            data: res.data.data.map((entry: any) => ({
              ...entry,
              startTime: new Date(entry.startTime),
              endTime: new Date(entry.endTime),
            })),
          },
        });
      } else {
        resolve({
          error: new Error(
            `Request failed with error: ${res.status} ${res.statusText}`,
          ),
        });
      }
    });
  }

  getStreams() {
    return new Promise<ServiceResult>(async (resolve, _reject) => {
      const res = await axios.get(new URL("streams", this.basePath).toString());

      if (res.status === 200) {
        resolve({
          data: {
            ...res.data,
            timestamp: new Date(res.data.timestamp),
            data: res.data.data,
          },
        });
      } else {
        resolve({
          error: new Error(
            `Request failed with error: ${res.status} ${res.statusText}`,
          ),
        });
      }
    });
  }

  getTimeline() {
    return new Promise<ServiceResult>(async (resolve, _reject) => {
      const res = await axios.get(
        new URL("artemis/timeline/artemis-II", this.basePath).toString(),
      );

      if (res.status === 200) {
        resolve({
          data: {
            ...res.data,
            timestamp: new Date(res.data.timestamp),
            data: res.data.data,
          },
        });
      } else {
        resolve({
          error: new Error(
            `Request failed with error: ${res.status} ${res.statusText}`,
          ),
        });
      }
    });
  }
}
